import React, { useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import OfsDate from "./OfsDate"
import { haveAuth } from "utils"
import OfsBranches from "./OfsBranches"
import OfsIsViewed from "./OfsIsViewed"
import { Button, SidebarModal } from "components"
import OfsAccessSelect from "./OfsAccessSelect"
import OfsUserSelect from "./OfsUserSelect"
import OsfAccessOnly from "./OsfAccessOnly"
import OsfUserOnly from "./OsfUserOnly"
import OfsIsDispatched from "./OfsIsDispatched"
import OfsDeliveryTypes from "./OfsDeliveryTypes"
import OfsLimit from "./OfsLimit"
import classes from "./index.module.scss"

const OrdersFilterSidebar = props => {
  const {
    filters,
    setFilters,
    openFilterSidebar,
    setOpenFilterSidebar,
    initialUsersList,
    setInitialUsersList,
    initialAccessList,
    setInitialAccessList
  } = props

  const [t] = useTranslation()

  const serviceTypeName =
    useSelector(state =>
      state.systemSettings.serviceTypeName
    )

  const { statusMultiple, ...initialFormState } = filters

  const [form, setForm] = useState(initialFormState)

  const handleApply = () => {
    setFilters(prev => ({ ...prev, ...form }))

    setOpenFilterSidebar(false)
  }

  const handleRemoveAll = () => {
    setFilters(prev => ({
      ...prev,
      fromDate: "",
      toDate: "",
      addedBySystem: null,
      branch: null,
      account: null,
      addedByAccount: null,
      isViewed: true,
      deliveryType: ""
    }))

    setOpenFilterSidebar(false)
  }

  const viewOtherAccessesOrders =
    haveAuth(["viewOtherAccessesOrders"])

  const showIsDispatched =
    serviceTypeName === "shop" &&
    filters.statusMultiple[0] === "delivered"

  return (
    <SidebarModal
      urlQuery="filter"
      urlQueryValue="true"
      title={t("فیلتر_سفارشات")}
      open={openFilterSidebar}
      onClose={() => setOpenFilterSidebar(false)}
    >
      <div className={classes["container"]}>
        <OfsBranches
          form={form}
          setForm={setForm}
        />

        <OfsDate
          form={form}
          setForm={setForm}
        />

        <OfsUserSelect
          form={form}
          setForm={setForm}
          initialUsersList={initialUsersList}
          setInitialUsersList={setInitialUsersList}
        />

        {
          viewOtherAccessesOrders &&
          <OfsAccessSelect
            form={form}
            setForm={setForm}
            initialAccessList={initialAccessList}
            setInitialAccessList={setInitialAccessList}
          />
        }

        <OfsDeliveryTypes
          form={form}
          setForm={setForm}
        />

        <OfsLimit
          form={form}
          setForm={setForm}
        />

        <OfsIsViewed
          form={form}
          setForm={setForm}
        />

        <OsfAccessOnly
          form={form}
          setForm={setForm}
        />

        <OsfUserOnly
          form={form}
          setForm={setForm}
        />

        {
          showIsDispatched &&
          <OfsIsDispatched
            form={form}
            setForm={setForm}
          />
        }

        <div className={classes["center"]}>
          <Button
            color="success"
            onClick={handleApply}
          >
            {t("اعمال")}
          </Button>

          <Button
            color="danger"
            onClick={handleRemoveAll}
            className={classes["button"]}
          >
            {t("حذف_فیلتر_ها")}
          </Button>
        </div>
      </div>
    </SidebarModal>
  )
}

export default OrdersFilterSidebar